const testConfig = {
  baseUrl: 'https://th-test-api.dimorder.com',
  mpUrl: 'https://th-test-mp-order.dimorder.com',
}

export default testConfig
